<!-- 未配置不扫描路径，显示占位符 -->
<div *ngIf="isFilePathEmpty; else hasFilePath">{{UNPLACEHOLDER}}</div>
<ng-template #hasFilePath>
    <ng-container *ngIf="entry === FilePathRenderEntryE.TABLE;else detailOrPreview">
        <div class="mes"
            [nTooltip]="excludeFilePathToolTip">
            <div *ngFor="let item of filePathArr"
                class="mes-item">
                <span class="mes-item-label">{{item}}</span>
            </div>
        </div>
        <ng-template #excludeFilePathToolTip>
            <div *ngFor="let item of filePathArr"
                class="mes-tip-item">
                <span class="mes-tip-item-label">{{item}}</span>
            </div>
        </ng-template>
    </ng-container>
    <ng-template #detailOrPreview>
        <div #mesContainer
            [ngClass]="{'hide-file-path': !showAll}"
            (nOnresize)="onResize()">
            <div *ngFor="let item of filePathArr"
                [ngStyle]="{
                    'max-width': maxWidth,
                    'cursor': item.length > tipMaxLenth ? 'pointer' : 'auto'
                }"
                class="mes-item"
                (click)="showDetail(item)">
                <span class="mes-item-label" nTextTips nTextTipsPlacement="top">{{overTipMaxLengthRender(item)}}</span>
            </div>
        </div>
        <a *ngIf="isMoreBtnShow" (click)="toggleFilePathView()">{{toggleBtnLabel}}</a>
    </ng-template>
</ng-template>
